import React, { Component } from "react";
import {
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
  Dimensions,
  Platform,
} from "react-native";
import { MaterialIcons } from "@expo/vector-icons";

/** Same icon family/name as LotsByLocation — works on Expo web (vector-icons in <Text> often shows a tofu square). */

export default class KeyboardBar extends Component {
  render() {
    const { abcOptionPress, scanOptionPress, containerStyle } = this.props;
    return (
      <View style={[styles.container, containerStyle]}>
        {abcOptionPress && (
          <TouchableOpacity
            onPress={abcOptionPress}
            style={styles.btn}
            activeOpacity={0.7}
            accessibilityRole="button"
            accessibilityLabel="Open lot list"
          >
            <Text style={styles.abcLabel}>ABC</Text>
          </TouchableOpacity>
        )}
        {scanOptionPress && (
          <TouchableOpacity
            onPress={scanOptionPress}
            style={styles.btn}
            activeOpacity={0.7}
            accessibilityRole="button"
            accessibilityLabel="Scan barcode"
          >
            <MaterialIcons
              name="qr-code-scanner"
              size={22}
              color="#424242"
              style={styles.scanIcon}
            />
          </TouchableOpacity>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#EDEEEE",
    flexDirection: "row",
    alignItems: "center",
    width: Dimensions.get("screen").width,
    paddingVertical: Platform.OS === "ios" ? 8 : 6,
    paddingHorizontal: 10,
    paddingRight: 8,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: "#c8c8c8",
    ...(Platform.OS === "web"
      ? {
          boxShadow: "0 -1px 4px rgba(0,0,0,0.08)",
        }
      : {
          shadowColor: "#000",
          shadowOffset: { width: 0, height: -1 },
          shadowOpacity: 0.08,
          shadowRadius: 3,
          elevation: 4,
        }),
  },
  btn: {
    backgroundColor: "#d8d8d8",
    minWidth: 52,
    minHeight: 40,
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 8,
    marginRight: 12,
    justifyContent: "center",
    alignItems: "center",
  },
  abcLabel: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "600",
    color: "#424242",
    fontFamily: Platform.OS === "web" ? "system-ui, -apple-system, sans-serif" : undefined,
  },
  scanIcon: {
    marginTop: Platform.OS === "android" ? 1 : 0,
  },
});
